<template>
  <div>
    <!-- 标题 -->
    <div class="Instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticComputeCloudMonitor">{{
          $t("alarms.instance.instance")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="Instance-top">
      <Row :gutter="16" v-show="isAWS">
        <Col span="7">
          <DatePicker
            ref="date"
            confirm
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('monitor.ec2.dashboard.selectTimeRange')"
            :options="dataOptions"
            style="min-width:350px"
            v-model="timeRegion"
            :clearable="false"
            @on-change="handleChangeTime"
            @on-ok="changeTimeType"
            @on-clear="handleClear"
          ></DatePicker>
        </Col>
        <Col span="5">
          <Select v-model="cycle" filterable @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : []"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 300px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import utils from "../../../../utils/utils.js";
export default {
  name: "Instance",
  data() {
    return {
      dataOptions: {
        disabledDate(value) {
          // 把当前时间的前 14天 后 14天之外的都禁用
          const startTime = new Date();
          const endTime = new Date();
          startTime.setDate(new Date().getDate() - 14);
          endTime.setDate(new Date().getDate() + 14);
          return !(value >= startTime && value <= endTime);
        }
      },
      startDate: "",
      endDate: "",
      timeRegion: [],
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // aws折线图
      awsList: [
        {
          id: "cpus",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent")
        },
        {
          id: "memoryUtilizations",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage")
        },
        {
          id: "cpudiskSpaceUtilizations",
          title: this.$t("alarms.instance.line.DiskUtilizationPercent")
        },
        {
          id: "DiskReadAndWrite",
          title: this.$t("alarms.instance.line.DiskReadAndWriteBytes")
        },
        {
          id: "DiskReadAndWriteOperations",
          title: this.$t(
            "alarms.instance.line.ReadAndWriteDiskOperationsOperations"
          )
        },
        {
          id: "NetworkInputAndOutput",
          title: this.$t("alarms.instance.line.NetworkInputAndOutputBytes")
        },
        {
          id: "NetworkPacketIncomingAndOutgoing",
          title: this.$t(
            "alarms.instance.line.IncomingAndOutgoingNetworkPacketsNumber"
          )
        }
      ],
      isAWS: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      instanceId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      privateIp: "",
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60
        }
      ],
      // echarts实例
      chart: "",
      chartDiskReadAndWrite: "",
      chartDiskReadAndWriteOperations: "",
      chartNetworkInputAndOutput: "",
      chartNetworkPacketIncomingAndOutgoing: "",
      chartMemoryUtilization: "",

      memoryUtilizationsOption: {},
      cpudiskSpaceUtilizationsOption: {},
      DiskReadAndWriteOption: {},
      DiskReadAndWriteOperationsOption: {},
      NetworkInputAndOutputOption: {},
      NetworkPacketIncomingAndOutgoingOption: {},

      // AWS数组
      cpuUtilizations: [],
      diskReadBytes: [],
      diskWriteBytes: [],
      diskReadOps: [],
      diskWriteOps: [],
      networkInput: [],
      networkOutput: [],
      networkPacketsIn: [],
      networkPacketsOut: [],
      memoryUtilization: [],
      cpudiskSpaceUtilization: [],
      cpudiskSpaceUtilizationList: [],
      xaxisData: [],
      // 新增预测数组
      cpuUtilizationsByAi: [],
      memoryUtilizationByAi: [],
      diskReadBytesByAi: [],
      diskWriteBytesByAi: [],
      diskReadOpsByAi: [],
      diskWriteOpsByAi: [],
      networkInputByAi: [],
      networkOutputByAi: [],
      networkPacketsInByAi: [],
      networkPacketsOutByAi: [],
      chartCpudiskSpaceUtilization: ""
    };
  },
  mounted: function() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chart.resize();
        self.chartMemoryUtilization.resize();
        self.chartCpudiskSpaceUtilization.resize();
        self.chartDiskReadAndWrite.resize();
        self.chartDiskReadAndWriteOperations.resize();
        self.chartNetworkInputAndOutput.resize();
        self.chartNetworkPacketIncomingAndOutgoing.resize();
      });
      this.init();
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      var myDate = new Date();
      let timestep = myDate.setHours(myDate.getHours(), 0, 0, 0); // 返回时间戳
      let timestep1 = myDate.setHours(myDate.getHours() + 1, 0, 0, 0); // 返回时间戳
      this.timeRegion[0] = this.startDate = utils.methods.formatDate(timestep);
      this.timeRegion[1] = this.endDate = utils.methods.formatDate(timestep1);
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function(item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // AWS
          if (item.id == "cpus") {
            var optionFll = this.cpusOption;
          } else if (item.id == "memoryUtilizations") {
            var optionFll = this.memoryUtilizationsOption;
          } else if (item.id == "cpudiskSpaceUtilizations") {
            var optionFll = this.cpudiskSpaceUtilizationsOption;
          } else if (item.id == "DiskReadAndWrite") {
            var optionFll = this.DiskReadAndWriteOption;
          } else if (item.id == "DiskReadAndWriteOperations") {
            var optionFll = this.DiskReadAndWriteOperationsOption;
          } else if (item.id == "NetworkInputAndOutput") {
            var optionFll = this.NetworkInputAndOutputOption;
          } else if (item.id == "NetworkPacketIncomingAndOutgoing") {
            var optionFll = this.NetworkPacketIncomingAndOutgoingOption;
          }
          fullChart.setOption(optionFll);
          window.addEventListener("resize", function() {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    // 查询时间范围
    queryTimeHorizon: function() {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        });
    },
    handleChangeTime(date) {
      if (!!date) {
        this.timeRegion = date;
        this.startDate = date[0];
        this.endDate = date[1];
      } else {
        this.timeRegion = [];
        this.startDate = "";
        this.endDate = "";
      }
    },
    // 切换AWS时间
    changeTimeType: function() {
      this.init();
    },
    // 切换AWS周期
    changeCycle: function() {
      this.init();
    },
    handleClear() {
      this.timeRegion = [];
      this.startDate = "";
      this.endDate = "";
      this.init();
    },
    /******************所有AWS折线图********************************/
    init: function() {
      if (!this.startDate || !this.endDate) {
        this.$Message.error(this.$t("monitor.ec2.dashboard.pleaseSelectDateRange"));
        return false;
      }
      this.cpusLine();
      this.chartDiskReadAndWriteLine();
      this.cpudiskSpaceUtilizationLine();
      this.chartDiskReadAndWriteOperationsLine();
      this.chartNetworkInputAndOutputLine();
      this.chartNetworkPacketIncomingAndOutgoingLine();
      this.memoryUtilizationLine();
    },
    // CPU利用率 (百分比)
    cpusLine: function() {
      this.chart = this.$echarts.init(this.$refs.cpus[0]);
      this.chart.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["CPUUtilization"]
        })
        .then(res => {
          this.chart.hideLoading();
          this.cpuUtilizations = res.data.cpuUtilizations;
          this.cpuUtilizationsByAi = res.data.cpuUtilizationsByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.cpusOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // CPU利用率
            legend: {
              type: "scroll",
              // x: "right",
              // y: "15px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.CPUUtilization"),
                this.$t("alarms.instance.line.CPUUtilizationForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.CPUUtilization"),
                type: "line",
                data: this.cpuUtilizations,
                itemStyle: {
                  normal: {
                    color: "#91c7ae",
                    lineStyle: {
                      color: "#91c7ae"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.CPUUtilizationForecast"),
                type: "line",
                data: this.cpuUtilizationsByAi,
                itemStyle: {
                  normal: {
                    color: "#8A2BE2",
                    lineStyle: {
                      color: "#8A2BE2"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chart.setOption(this.cpusOption, true);
        })
        .catch(err => {
          this.chart.hideLoading();
        });
    },
    // 内存使用率 (百分比)
    memoryUtilizationLine: function() {
      this.chartMemoryUtilization = this.$echarts.init(
        this.$refs.memoryUtilizations[0]
      );
      this.chartMemoryUtilization.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["MemoryUtilization"]
        })
        .then(res => {
          this.chartMemoryUtilization.hideLoading();
          this.memoryUtilization = res.data.memoryUtilization;
          this.memoryUtilizationByAi = res.data.memoryUtilizationByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.memoryUtilizationsOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 内存使用率
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.MemoryUsage"),
                this.$t("alarms.instance.line.MemoryUsageForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.MemoryUsage"),
                type: "line",
                data: this.memoryUtilization,
                itemStyle: {
                  normal: {
                    color: "#ceca58",
                    lineStyle: {
                      color: "#ceca58"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.MemoryUsageForecast"),
                type: "line",
                data: this.memoryUtilizationByAi,
                itemStyle: {
                  normal: {
                    color: "#A52A2A",
                    lineStyle: {
                      color: "#A52A2A"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartMemoryUtilization.setOption(
            this.memoryUtilizationsOption,
            true
          );
        })
        .catch(err => {
          this.chartMemoryUtilization.hideLoading();
        });
    },
    // 磁盘利用率 (百分比)
    cpudiskSpaceUtilizationLine: function() {
      this.chartCpudiskSpaceUtilization = this.$echarts.init(
        this.$refs.cpudiskSpaceUtilizations[0]
      );
      this.chartCpudiskSpaceUtilization.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DiskSpaceUtilization"]
        })
        .then(res => {
          this.chartCpudiskSpaceUtilization.hideLoading();
          // 多磁盘
          this.cpudiskSpaceUtilization = res.data.cpudiskSpaceUtilization.concat(
            res.data.cpudiskSpaceUtilizationByAi
          );
          if (this.cpudiskSpaceUtilization == undefined) {
            return;
          }
          this.cpudiskSpaceUtilizationList = [];
          for (var i = 0; i < this.cpudiskSpaceUtilization.length; i++) {
            var CpudiskSpaceUtilizationCopy = new Object();
            CpudiskSpaceUtilizationCopy.name = this.cpudiskSpaceUtilization[
              i
            ].name;
            this.cpudiskSpaceUtilizationList.push(CpudiskSpaceUtilizationCopy);
          }
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.cpudiskSpaceUtilizationsOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: this.cpudiskSpaceUtilizationList
            },
            series: this.cpudiskSpaceUtilization,
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartCpudiskSpaceUtilization.setOption(
            this.cpudiskSpaceUtilizationsOption,
            true
          );
        })
        .catch(err => {
          this.chartCpudiskSpaceUtilization.hideLoading();
        });
    },
    // 磁盘读写 (字节)
    chartDiskReadAndWriteLine: function() {
      this.chartDiskReadAndWrite = this.$echarts.init(
        this.$refs.DiskReadAndWrite[0]
      );
      // 调用showLoading方法
      this.chartDiskReadAndWrite.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DiskReadBytes", "DiskWriteBytes"]
        })
        .then(res => {
          this.chartDiskReadAndWrite.hideLoading();
          this.diskReadBytes = res.data.diskReadBytes;
          this.diskWriteBytes = res.data.diskWriteBytes;
          this.diskReadBytesByAi = res.data.diskReadBytesByAi;
          this.diskWriteBytesByAi = res.data.diskWriteBytesByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.DiskReadAndWriteOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 磁盘读 磁盘写
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.DiskRead"),
                this.$t("alarms.instance.line.DiskWrite"),
                this.$t("alarms.instance.line.DiskReadForecast"),
                this.$t("alarms.instance.line.DiskWriteForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.DiskRead"),
                type: "line",
                data: this.diskReadBytes,
                itemStyle: {
                  normal: {
                    color: "#123421",
                    lineStyle: {
                      color: "#123421"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.DiskWrite"),
                type: "line",
                data: this.diskWriteBytes,
                itemStyle: {
                  normal: {
                    color: "#7f4554",
                    lineStyle: {
                      color: "#7f4554"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.DiskReadForecast"),
                type: "line",
                data: this.diskReadBytesByAi,
                itemStyle: {
                  normal: {
                    color: "#FFE4C4",
                    lineStyle: {
                      color: "#FFE4C4"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.DiskWriteForecast"),
                type: "line",
                data: this.diskWriteBytesByAi,
                itemStyle: {
                  normal: {
                    color: "#6495ED",
                    lineStyle: {
                      color: "	#6495ED"
                    }
                  }
                }
              }
            ],
            grid: {
              left: "3%",
              bottom: "3%",
              top: "20%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartDiskReadAndWrite.setOption(
            this.DiskReadAndWriteOption,
            true
          );
        })
        .catch(err => {
          this.chartDiskReadAndWrite.hideLoading();
        });
    },
    // 读写磁盘操作 (操作)
    chartDiskReadAndWriteOperationsLine: function() {
      this.chartDiskReadAndWriteOperations = this.$echarts.init(
        this.$refs.DiskReadAndWriteOperations[0]
      );
      this.chartDiskReadAndWriteOperations.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });

      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DiskReadOps", "DiskWriteOps"]
        })
        .then(res => {
          this.chartDiskReadAndWriteOperations.hideLoading();
          this.diskReadOps = res.data.diskReadOps;
          this.diskWriteOps = res.data.diskWriteOps;
          this.diskReadOpsByAi = res.data.diskReadOpsByAi;
          this.diskWriteOpsByAi = res.data.diskWriteOpsByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.DiskReadAndWriteOperationsOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 磁盘读操作 磁盘写操作
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.DiskReadOperation"),
                this.$t("alarms.instance.line.DiskWriteOperation"),
                this.$t("alarms.instance.line.DiskReadOperationForecast"),
                this.$t("alarms.instance.line.DiskWriteOperationForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.DiskReadOperation"),
                type: "line",
                data: this.diskReadOps,
                itemStyle: {
                  normal: {
                    color: "#61a0a8",
                    lineStyle: {
                      color: "#61a0a8"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.DiskWriteOperation"),
                type: "line",
                data: this.diskWriteOps,
                itemStyle: {
                  normal: {
                    color: "#DC143C",
                    lineStyle: {
                      color: "#DC143C"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.DiskReadOperationForecast"),
                type: "line",
                data: this.diskReadOpsByAi,
                itemStyle: {
                  normal: {
                    color: " #c23159",
                    lineStyle: {
                      color: "#c23159"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.instance.line.DiskWriteOperationForecast"
                ),
                type: "line",
                data: this.diskWriteOpsByAi,
                itemStyle: {
                  normal: {
                    color: "#9932CC",
                    lineStyle: {
                      color: "#9932CC"
                    }
                  }
                }
              }
            ],
            grid: {
              left: "3%",
              bottom: "3%",
              top: "20%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartDiskReadAndWriteOperations.setOption(
            this.DiskReadAndWriteOperationsOption,
            true
          );
        })
        .catch(err => {
          this.chartDiskReadAndWriteOperations.hideLoading();
        });
    },
    // 网络输入输出 (字节)
    chartNetworkInputAndOutputLine: function() {
      this.chartNetworkInputAndOutput = this.$echarts.init(
        this.$refs.NetworkInputAndOutput[0]
      );
      this.chartNetworkInputAndOutput.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });

      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["NetworkIn", "NetworkOut"]
        })
        .then(res => {
          this.chartNetworkInputAndOutput.hideLoading();
          this.networkInput = res.data.networkInput;
          this.networkOutput = res.data.networkOutput;
          this.networkInputByAi = res.data.networkInputByAi;
          this.networkOutputByAi = res.data.networkOutputByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.NetworkInputAndOutputOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 网络输入 网络输出
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.NetworkInput"),
                this.$t("alarms.instance.line.NetworkOutput"),
                this.$t("alarms.instance.line.NetworkInputForecast"),
                this.$t("alarms.instance.line.NetworkOutputForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.NetworkInput"),
                type: "line",
                data: this.networkInput,
                itemStyle: {
                  normal: {
                    color: "#ccc",
                    lineStyle: {
                      color: "#ccc"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.NetworkOutput"),
                type: "line",
                data: this.networkOutput,
                itemStyle: {
                  normal: {
                    color: "#4671D5",
                    lineStyle: {
                      color: "#4671D5"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.NetworkInputForecast"),
                type: "line",
                data: this.networkInputByAi,
                itemStyle: {
                  normal: {
                    color: "#E9967A",
                    lineStyle: {
                      color: "#E9967A"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.NetworkOutputForecast"),
                type: "line",
                data: this.networkOutputByAi,
                itemStyle: {
                  normal: {
                    color: "#BDB76B",
                    lineStyle: {
                      color: "#BDB76B"
                    }
                  }
                }
              }
            ],
            grid: {
              left: "3%",
              bottom: "3%",
              top: "20%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartNetworkInputAndOutput.setOption(
            this.NetworkInputAndOutputOption,
            true
          );
        })
        .catch(err => {
          this.chartNetworkInputAndOutput.hideLoading();
        });
    },
    // 网络数据包传入传出 (数量)
    chartNetworkPacketIncomingAndOutgoingLine: function() {
      this.chartNetworkPacketIncomingAndOutgoing = this.$echarts.init(
        this.$refs.NetworkPacketIncomingAndOutgoing[0]
      );
      this.chartNetworkPacketIncomingAndOutgoing.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });

      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 0,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["NetworkPacketsIn", "NetworkPacketsOut"]
        })
        .then(res => {
          this.chartNetworkPacketIncomingAndOutgoing.hideLoading();
          this.networkPacketsIn = res.data.networkPacketsIn;
          this.networkPacketsOut = res.data.networkPacketsOut;
          this.networkPacketsInByAi = res.data.networkPacketsInByAi;
          this.networkPacketsOutByAi = res.data.networkPacketsOutByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.NetworkPacketIncomingAndOutgoingOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 网络数据包传入 网络数据包传出
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.instance.line.IncomingNetworkPackets"),
                this.$t("alarms.instance.line.OutgoingNetworkPackets"),
                this.$t("alarms.instance.line.IncomingNetworkPacketsForecast"),
                this.$t("alarms.instance.line.OutgoingNetworkPacketsForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.instance.line.IncomingNetworkPackets"),
                type: "line",
                data: this.networkPacketsIn,
                itemStyle: {
                  normal: {
                    color: "#803500",
                    lineStyle: {
                      color: "#803500"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.instance.line.OutgoingNetworkPackets"),
                type: "line",
                data: this.networkPacketsOut,
                itemStyle: {
                  normal: {
                    color: "#FF9B40",
                    lineStyle: {
                      color: "#FF9B40"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.instance.line.IncomingNetworkPacketsForecast"
                ),
                type: "line",
                data: this.networkPacketsInByAi,
                itemStyle: {
                  normal: {
                    color: "#8FBC8F",
                    lineStyle: {
                      color: "#8FBC8F"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.instance.line.OutgoingNetworkPacketsForecast"
                ),
                type: "line",
                data: this.networkPacketsOutByAi,
                itemStyle: {
                  normal: {
                    color: "#FF8C00",
                    lineStyle: {
                      color: "#FF8C00"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartNetworkPacketIncomingAndOutgoing.setOption(
            this.NetworkPacketIncomingAndOutgoingOption,
            true
          );
        })
        .catch(err => {
          this.chartNetworkPacketIncomingAndOutgoing.hideLoading();
        });
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.privateIp = this.$route.query.privateIp;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: "/monitor/elasticComputeCloudDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.Instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.Instance-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/instance_dashboard/InstanceForecast.vue